import * as React from "react";
import { SVGProps, memo } from "react";
const SvgDatasourceExtractIcon14Px = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={14}
    height={14}
    fill="none"
    role="img"
    {...props}
  >
    <path
      d="M4 7V6h1v1a2 2 0 0 0 2 2h1V7.534a.25.25 0 0 1 .41-.192l2.36 1.966c.12.1.12.284 0 .384l-2.36 1.966a.25.25 0 0 1-.41-.192V10H7a3 3 0 0 1-3-3Z"
      fill="#666"
    />
    <path
      d="M5.29 3.938c-.246.04-.51.062-.79.062-.825 0-1.522-.193-1.979-.454C2.036 3.269 2 3.039 2 3c0-.039.036-.269.521-.546C2.978 2.194 3.675 2 4.5 2c.825 0 1.522.193 1.979.454.108.062.193.12.261.176a5.34 5.34 0 0 1 .998-.391C7.214 1.512 5.96 1 4.5 1 2.567 1 1 1.895 1 3v6c0 1.105 1.567 2 3.5 2 .17 0 .337-.007.5-.02v-.515a4.017 4.017 0 0 1-.648-.467c-.76-.022-1.402-.207-1.83-.452C2.035 9.269 2 9.039 2 9V4.517C2.74 4.835 3.614 5 4.5 5c.167 0 .334-.006.5-.018.003-.367.105-.719.29-1.044Z"
      fill="#666"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M6 5v2a1 1 0 0 0 1 1V6.517c.116.05.236.096.358.138a1.248 1.248 0 0 1 1.692-.082L9.562 7c.865-.008 1.715-.172 2.438-.483V11c0 .039-.036.269-.521.546-.445.254-1.12.444-1.917.454l-.512.427c-.814.678-2.05.099-2.05-.96V11a4.01 4.01 0 0 1-1-.126V11c0 1.105 1.567 2 3.5 2s3.5-.895 3.5-2V5c0-1.105-1.567-2-3.5-2S6 3.895 6 5Zm6 0c0 .039-.036.269-.521.546-.457.26-1.154.454-1.979.454-.825 0-1.522-.193-1.979-.454C7.036 5.269 7 5.039 7 5c0-.039.036-.269.521-.546C7.978 4.194 8.675 4 9.5 4c.825 0 1.522.193 1.979.454.485.277.521.507.521.546Z"
      fill="#666"
    />
  </svg>
);
const Memo = memo(SvgDatasourceExtractIcon14Px);
export default Memo;
